const _import = require('./_import_' + process.env.NODE_ENV);

export default [
  {
    path: '/manage/preview',
    name: 'EnterprisePreview',
    component: _import('preview/index')
  },
  {
    path: '/print',
    name: 'EnterprisePrint',
    component: _import('preview/print')
  },
  {
    path: '/download',
    name: 'EnterpriseDownload',
    component: _import('preview/download')
  }
];



// WEBPACK FOOTER //
// ./src/router/preview.router.js